import {
  isProduction,
  isStage,
  isAWSProduction,
  isAWSStage,
} from 'util/environment'

import { CreateOrgRoute, CreateUserRoute } from 'resources/routes'

const githubRedirectUriLogin = () => {
  const host =
    window.location.host === 'devstportal.victorops.com'
      ? 'stportal.victorops.com'
      : window.location.host
  return `https://${host}/auth/external/signin/github`
}

const githubRedirectUriCreateOrg = () => {
  const host =
    window.location.host === 'devstportal.victorops.com'
      ? 'stportal.victorops.com'
      : window.location.host
  return `https://${host}/membership/#${CreateOrgRoute}`
}

const githubRedirectUriCreateUser = token => {
  const host =
    window.location.host === 'devstportal.victorops.com'
      ? 'stportal.victorops.com'
      : window.location.host
  const route = CreateUserRoute.split(':')[0] + token
  return `https://${host}/membership/#${route}`
}

const getGithubKey = () => {
  const devKey = 'c4ff1827feecbd04373d'
  const stageKey = 'ed9701632d14215cbf1a'
  const prodKey = 'ac602ab727ecde8f4d0d'

  const awsStageKey = '7efd16879c920e1bf666'
  const awsProdKey = 'c5e3b21628fbab5d384a'

  if (isStage()) {
    return stageKey
  } else if (isProduction()) {
    return prodKey
  } else if (isAWSStage()) {
    return awsStageKey
  } else if (isAWSProduction()) {
    return awsProdKey
  } else {
    return devKey
  }
}

export const getGithubAuthLinkLogin = () => {
  const clientId = encodeURIComponent(getGithubKey())
  const redirectUri = encodeURIComponent(githubRedirectUriLogin())
  return `https://github.com/login/oauth/authorize?scope=read:user%20user:email&client_id=${clientId}&redirect_uri=${redirectUri}`
}

export const getGithubAuthLinkCreateOrg = () => {
  const clientId = encodeURIComponent(getGithubKey())
  const redirectUri = encodeURIComponent(githubRedirectUriCreateOrg())
  return `https://github.com/login/oauth/authorize?scope=read:user%20user:email&client_id=${clientId}&redirect_uri=${redirectUri}`
}

export const getGithubAuthLinkCreateUser = token => {
  const clientId = encodeURIComponent(getGithubKey())
  const redirectUri = encodeURIComponent(githubRedirectUriCreateUser(token))
  return `https://github.com/login/oauth/authorize?scope=read:user%20user:email&client_id=${clientId}&redirect_uri=${redirectUri}`
}
